import { resolvePermissions } from '@paintscout/util/builder'
import { getDefaultSeatPermissions } from '@paintscout/util/users'
import type { AppMetadata } from 'paintscout'
import type { PainterScheduleEvent } from '../PainterScheduleView'

export function getPainterSchedulePermissions(args: {
  appMetadata?: AppMetadata
  isPainter?: boolean
  forcePainterPreview?: boolean
}) {
  const { appMetadata, isPainter = false, forcePainterPreview = false } = args

  if (forcePainterPreview && !isPainter) {
    return getDefaultSeatPermissions('painter', 'employee')
  }

  return appMetadata ? resolvePermissions(appMetadata) : []
}

export function getPainterScheduleEvents(args: {
  realEvents?: PainterScheduleEvent[]
  mockEvents: PainterScheduleEvent[]
}) {
  const { realEvents = [], mockEvents } = args
  return realEvents.length > 0 ? realEvents : mockEvents
}
